module.exports = __webpack_public_path__ + "65185f1fd7933c2c4c035bb8045c943e.svg";